import { render, staticRenderFns } from "./PurchaseTexts.vue?vue&type=template&id=4351945c&scoped=true&"
import script from "./PurchaseTexts.vue?vue&type=script&lang=js&"
export * from "./PurchaseTexts.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseTexts.vue?vue&type=style&index=0&id=4351945c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4351945c",
  null
  
)

export default component.exports